import type {IMenuItem} from '../interfaces/IMenuItem';

const Home: IMenuItem = {
  title: 'Accueil',
  type: 'home',
  url: '',
  img: [],
  more: undefined,
  subMenu: undefined
};

const Agenda: IMenuItem = {
  title: 'Agenda',
  type: 'agenda',
  url: '/agenda',
  img: [],
  more: undefined,
  subMenu: undefined
};

// const Infos: IMenuItem = {
//   title: 'Infos pratiques',
//   type: 'infos',
//   url: '/infos',
//   img: [],
//   more: undefined,
//   subMenu: undefined
// };

const Registration: IMenuItem = {
  title: 'Inscriptions',
  type: 'registration',
  url: '/registration',
  img: [],
  more: undefined,
  subMenu: undefined
};

// const CheckIn: IMenuItem = {
//   title: 'Check-in',
//   type: 'checkin',
//   url: '/checkin',
//   img: [],
//   more: undefined,
//   subMenu: undefined
// };

const Contact: IMenuItem = {
  title: 'Contact',
  type: 'contact',
  url: '/contact',
  img: [],
  more: undefined,
  subMenu: undefined
};

// Affiché dans le menu uniquement quand on est connecté (voir Header).
export const AdminLink: IMenuItem = {
  title: 'Admin',
  type: 'admin',
  url: '/admin',
  img: [],
  more: undefined,
  subMenu: undefined
};

export const Links: IMenuItem[] = [
  Home,
  Agenda,
  // Infos,
  Registration,
  // CheckIn,
  Contact,
  // Admin,
];
